// extracted by mini-css-extract-plugin
export default {"root":"_3trEa","left":"_3RIqG","right":"_1a2aW"};